import dayjs, { Dayjs } from 'dayjs';
interface DisabledTimes {
  disabledHours?: () => number[];
  disabledMinutes?: (selectedHour: number) => number[];
}

export const disabledTime = (): DisabledTimes => {
  return {
    disabledHours: () => [0, 1, 2, 3, 4, 5, 6, 7, 8, 19, 20, 21, 22, 23],
  };
};

// Calculate the date 6 days from today
// @ts-ignore
const sixDaysFromNow = dayjs().add(6, 'days');

// @ts-ignore
const today = dayjs();

// enable only six days from today
export const disabledDate = (current: Dayjs | undefined) => {
  return current
    ? current.isBefore(today, 'day') || current.isAfter(sixDaysFromNow, 'day')
    : false;
};
